import React from "react";
import {
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";

const StandardCakeFlavors = ({ formData, setFormData, flavorOptions }) => {
  const handleChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      flavors: value, // flavor._id values
    }));
  };

  return (
    <>
      <Typography sx={{ mt: 2, mb: 1 }}>Flavors</Typography>
      <FormControl fullWidth>
        <InputLabel>Select Flavors</InputLabel>
        <Select
          multiple
          value={formData.flavors.map((f) => f._id)}
          onChange={(e) => {
            const selectedIds = e.target.value;
            const selectedFlavors = flavorOptions.filter((f) =>
              selectedIds.includes(f._id)
            );
            setFormData((prev) => ({
              ...prev,
              flavors: selectedFlavors,
            }));
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 280, // scroll if more than ~6-7 items
                width: "auto", // allow width to be based on content
                padding: 0,
              },
            },
          }}
          renderValue={(selected) =>
            selected
              .map((id) => {
                const flavor = flavorOptions.find((f) => f._id === id);
                return flavor ? flavor.displayName : "";
              })
              .join(", ")
          }>
          {flavorOptions.map((flavor) => (
            <MenuItem
              key={flavor._id}
              value={flavor._id}
              sx={{ py: 0.5, px: 1.5 }} // tighter spacing
            >
              <Checkbox
                checked={formData.flavors.some((f) => f._id === flavor._id)}
                sx={{ padding: 0.5 }} // compact checkbox
              />
              <ListItemText
                primary={flavor.displayName}
                primaryTypographyProps={{ fontSize: 14 }}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default StandardCakeFlavors;
